module.exports = __webpack_public_path__ + "preview.svg?2c78f90cf4b9a0c7e92afe18238a17c9";